export default __webpack_public_path__ + "static/media/blog1.bde8ac4a.jpg";